"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SmartphoneSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SmartphoneSVG = function SmartphoneSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M23 1H9a2 2 0 00-2 2v26a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm-8 2h2a1 1 0 010 2h-2a1 1 0 010-2zm-3 0a1 1 0 11-1 1 1 1 0 011-1zm3 25a1 1 0 111 1 1 1 0 01-1-1zm8-3H9V7h14z"
  }));
};
exports.SmartphoneSVG = SmartphoneSVG;
SmartphoneSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SmartphoneSVG);
exports.default = _default;